import {createContext, useMemo, useContext, useReducer, type FC, type Dispatch} from 'react';

import {type InputMenuState, type InputMenuAction} from 'interfaces';

import inputMenuReducer from 'reducers/inputMenu';

const InputMenuContext = createContext<IInputValue | undefined>(undefined);
export const useInputMenuContext = () => useContext(InputMenuContext);

interface IInputValue {
  state: InputMenuState;
  dispatch: Dispatch<InputMenuAction>;
}

export const InputMenuProvider: FC<any> = ({children}) => {
  const [state, dispatch] = useReducer(inputMenuReducer, {
    formData: {date: new Date()},
    popOver: {open: false},
  });

  return (
    <InputMenuContext.Provider value={useMemo(() => ({state, dispatch}), [state])}>
      {children}
    </InputMenuContext.Provider>
  );
};

/**
 * For tests only
 * @deprecated
 */
